export const site = {
  brandName: 'Avvocato Federico Salucci',
  studioName: 'Studio Legale Salucci',
  siteUrl: 'https://avvocatofedericosalucci.it',
  phoneLabel: '375 907 9625',
  phoneHref: '+393759079625',
  addressShort: 'Roma, Via Monte Urano n. 47',
  address: {
    streetAddress: 'Via Monte Urano n. 47',
    addressLocality: 'Roma',
    addressCountry: 'IT'
  },
  secondaryLocation: 'Viterbo, previo appuntamento',
  serviceArea: 'Roma, Viterbo, Italia e consulenze online',
  mapUrl:
    'https://www.google.com/maps/search/?api=1&query=Via%20Monte%20Urano%2047%20Roma',
  creditsUrl: 'https://www.ioppolostudio.com/',
  logo: '/logo-avvocato-federico-salucci.svg',
  heroImage: '/images/hero-pixabay-law.jpg',
  portraitImage: '/images/federico-salucci-ritratto.webp',
  courtImage: '/images/federico-salucci-corte-appello-roma.webp',
  stock: {
    library: '/images/stock-legal-library.jpg',
    family: '/images/stock-family.jpg',
    work: '/images/stock-work.jpg',
    car: '/images/stock-sinistri.jpg',
    civil: '/images/stock-civil.jpg',
    immigration: '/images/stock-immigrazione.jpg',
    consultation: '/images/stock-consulenza.jpg',
    rome: '/images/stock-rome.jpg',
    contactHero: '/images/hero-contatti-roma.jpg'
  }
};

const whatsappBase = `https://wa.me/393759079625`;

export function whatsappUrl(message) {
  return `${whatsappBase}?text=${encodeURIComponent(message)}`;
}

export const navLinks = [
  { label: 'Aree', href: '/#aree' },
  { label: 'Metodo', href: '/#metodo' },
  { label: 'Avvocato', href: '/#avvocato' },
  { label: 'Blog', href: '/blog' },
  { label: 'Contatti', href: '/contatti' }
];

export const areaPages = [
  {
    slug: 'diritto-di-famiglia',
    path: '/diritto-di-famiglia',
    icon: 'HeartHandshake',
    image: site.stock.family,
    eyebrow: 'Famiglia e persona',
    title: 'Diritto di famiglia',
    shortTitle: 'Famiglia',
    headline: 'Un’assistenza riservata nei momenti familiari più delicati.',
    description:
      'Separazioni, divorzi, affidamento dei figli, mantenimento e tutela delle persone vulnerabili con un approccio chiaro, concreto e orientato alla protezione della persona.',
    metaTitle: 'Avvocato diritto di famiglia a Roma | Federico Salucci',
    metaDescription:
      'Assistenza legale a Roma per separazione, divorzio, affidamento figli, mantenimento, responsabilità genitoriale e amministrazione di sostegno.',
    proof:
      'Il percorso viene impostato privilegiando, quando possibile, soluzioni consensuali che riducano conflitto, tempi e costi.',
    services: [
      'Separazione consensuale e giudiziale',
      'Divorzio congiunto e giudiziale',
      'Affidamento, collocamento e diritto di visita dei figli',
      'Assegno di mantenimento, spese straordinarie e casa familiare',
      'Responsabilità genitoriale e tutela dei minori',
      'Rapporti tra genitori non coniugati',
      'Ordini di protezione contro abusi familiari',
      'Amministrazione di sostegno, interdizione e inabilitazione',
      'Negoziazione assistita e procedure stragiudiziali'
    ],
    steps: [
      'Ricostruzione dei fatti e degli obiettivi familiari',
      'Valutazione della strada consensuale o giudiziale',
      'Tutela dei figli minori e degli aspetti patrimoniali',
      'Assistenza fino alla definizione dell’accordo o del procedimento'
    ],
    faqs: [
      {
        q: 'La separazione consensuale è sempre possibile?',
        a: 'È possibile quando i coniugi raggiungono un accordo sui punti essenziali. Se l’accordo non è realistico, lo Studio valuta la strategia giudiziale più adatta.'
      },
      {
        q: 'Si può modificare un accordo di separazione o divorzio?',
        a: 'Sì, quando cambiano le condizioni economiche, familiari o personali. La modifica deve essere motivata e documentata.'
      }
    ]
  },
  {
    slug: 'diritto-penale-penitenziario',
    path: '/diritto-penale-penitenziario',
    icon: 'Gavel',
    image: site.stock.library,
    eyebrow: 'Difesa e processo',
    title: 'Diritto penale e penitenziario',
    shortTitle: 'Penale',
    headline: 'Difesa penale dalla prima fase del procedimento.',
    description:
      'Assistenza a indagati, imputati e persone offese dal reato, con attenzione alla strategia difensiva, all’analisi degli atti e alla tutela dei diritti dell’assistito.',
    metaTitle: 'Avvocato penalista a Roma | Federico Salucci',
    metaDescription:
      'Difesa penale a Roma per indagini preliminari, querele, persona offesa, misure cautelari, reati contro persona e patrimonio, diritto penitenziario.',
    proof:
      'La difesa viene costruita partendo dagli atti, dalle urgenze processuali e dalla posizione concreta dell’assistito.',
    services: [
      'Assistenza durante le indagini preliminari',
      'Difesa in procedimenti penali ordinari',
      'Denunce, querele, esposti e opposizioni ad archiviazione',
      'Assistenza alla persona offesa e costituzione di parte civile',
      'Riesame, appelli cautelari e misure cautelari',
      'Reati contro la persona e contro il patrimonio',
      'Lesioni, minacce, stalking e maltrattamenti in famiglia',
      'Guida in stato di ebbrezza o sotto sostanze stupefacenti',
      'Impugnazioni di sentenze penali'
    ],
    secondaryTitle: 'Diritto penitenziario',
    secondaryServices: [
      'Affidamento in prova al servizio sociale',
      'Detenzione domiciliare, semilibertà e liberazione anticipata',
      'Permessi premio e misure alternative alla detenzione',
      'Istanze al Magistrato di Sorveglianza',
      'Reclami contro provvedimenti dell’Amministrazione Penitenziaria'
    ],
    steps: [
      'Analisi urgente della posizione e degli atti disponibili',
      'Individuazione dei rischi processuali e delle scadenze',
      'Costruzione della linea difensiva',
      'Assistenza nei rapporti con Autorità, consulenti e familiari'
    ],
    faqs: [
      {
        q: 'Quando serve contattare un avvocato penalista?',
        a: 'Appena arriva una convocazione, una notifica, una perquisizione, un sequestro o una querela. Intervenire subito permette di proteggere meglio la posizione.'
      },
      {
        q: 'Lo Studio assiste anche la persona offesa?',
        a: 'Sì. Lo Studio segue denunce, querele, opposizioni ad archiviazione e costituzione di parte civile quando vi sono i presupposti.'
      }
    ]
  },
  {
    slug: 'invalidita-civile-lavoro',
    path: '/invalidita-civile-lavoro',
    icon: 'BriefcaseMedical',
    image: site.stock.work,
    eyebrow: 'Lavoro, INPS e INAIL',
    title: 'Invalidità civile, lavoro e malattie professionali',
    shortTitle: 'Lavoro e invalidità',
    headline: 'Tutela legale e medico-legale per lavoratori, pensionati e cittadini.',
    description:
      'Assistenza in diritto del lavoro, invalidità civile, Legge 104, malattie professionali e infortuni sul lavoro, con il supporto di consulenti tecnici e medici legali.',
    metaTitle: 'Invalidità civile, lavoro e malattie professionali | Avv. Salucci',
    metaDescription:
      'Assistenza a Roma per invalidità civile, Legge 104, ricorsi INPS e INAIL, malattie professionali, infortuni sul lavoro e controversie lavoristiche.',
    proof:
      'Questo ambito rappresenta uno dei principali approfondimenti professionali dell’Avvocato Salucci, già oggetto della tesi di laurea in diritto del lavoro.',
    services: [
      'Impugnazione di licenziamenti e contestazioni disciplinari',
      'Recupero crediti da lavoro e differenze retributive',
      'Mobbing, straining e tutela del lavoratore',
      'Contratti di lavoro e riconoscimento del rapporto subordinato',
      'Invalidità civile, Legge 104 e indennità di accompagnamento',
      'Ricorsi contro verbali INPS e procedure di aggravamento',
      'Accertamento Tecnico Preventivo ex art. 445-bis c.p.c.',
      'Malattie professionali, rendite e dinieghi INAIL',
      'Infortuni sul lavoro, infortuni in itinere e danno biologico'
    ],
    steps: [
      'Raccolta della documentazione medica, lavorativa e previdenziale',
      'Valutazione con consulenti tecnici e medici legali',
      'Scelta della procedura amministrativa o giudiziale',
      'Assistenza fino al riconoscimento delle prestazioni dovute'
    ],
    faqs: [
      {
        q: 'Cosa fare dopo un verbale INPS negativo?',
        a: 'È importante verificare subito termini, documentazione medica e possibilità di ricorso. In molti casi serve una valutazione medico-legale mirata.'
      },
      {
        q: 'Le malattie professionali richiedono un medico legale?',
        a: 'Spesso sì, perché il nesso tra patologia e attività lavorativa va documentato con precisione tecnica oltre che giuridica.'
      }
    ]
  },
  {
    slug: 'sinistri-stradali',
    path: '/sinistri-stradali',
    icon: 'Car',
    image: site.stock.car,
    eyebrow: 'Risarcimenti e patente',
    title: 'Sinistri stradali e tutela dell’automobilista',
    shortTitle: 'Sinistri stradali',
    headline: 'Danni, assicurazioni, patente e responsabilità dopo un incidente.',
    description:
      'Assistenza a conducenti, proprietari, trasportati e familiari nella gestione dei danni civili, amministrativi e penali legati ai sinistri stradali.',
    metaTitle: 'Avvocato sinistri stradali a Roma | Federico Salucci',
    metaDescription:
      'Risarcimento danni da incidente stradale, danni fisici, assicurazioni, sospensione patente, sequestro veicoli e tutela dell’automobilista.',
    proof:
      'Lo Studio collabora con periti, consulenti tecnici e medici legali per ricostruire il danno e tutelare correttamente la posizione del cliente.',
    services: [
      'Risarcimento danni da incidente stradale',
      'Lesioni personali, danno biologico, morale e patrimoniale',
      'Danni al veicolo e trattative con compagnie assicurative',
      'Risarcimento diretto, sinistri con veicoli esteri e sinistri mortali',
      'Opposizione a verbali e sanzioni amministrative',
      'Ricorsi contro sospensione o revoca della patente',
      'Restituzione della patente e procedimenti presso Motorizzazione',
      'Sequestro amministrativo o penale del veicolo',
      'Istanze di dissequestro e opposizione alla confisca'
    ],
    steps: [
      'Analisi di dinamica, verbali, foto e documenti assicurativi',
      'Valutazione dei danni con periti e medici legali',
      'Gestione del rapporto con la compagnia assicurativa',
      'Azione giudiziale quando il risarcimento non è corretto'
    ],
    faqs: [
      {
        q: 'È utile chiamare l’avvocato prima di parlare con l’assicurazione?',
        a: 'Sì, soprattutto quando ci sono lesioni, responsabilità contestata, patente sospesa o importi rilevanti.'
      },
      {
        q: 'Lo Studio segue anche sospensione e restituzione della patente?',
        a: 'Sì. La tutela può riguardare sia il risarcimento sia il profilo amministrativo o penale collegato alla guida.'
      }
    ]
  },
  {
    slug: 'immigrazione-cittadinanza',
    path: '/immigrazione-cittadinanza',
    icon: 'Globe2',
    image: site.stock.immigration,
    eyebrow: 'Cittadinanza e permessi',
    title: 'Immigrazione e cittadinanza italiana',
    shortTitle: 'Immigrazione',
    headline: 'Assistenza per cittadini italiani e stranieri nelle procedure di immigrazione.',
    description:
      'Supporto in pratiche di cittadinanza italiana, dinieghi, ricorsi, ricongiungimenti familiari e giudizi davanti ai Tribunali Amministrativi Regionali.',
    metaTitle: 'Avvocato immigrazione e cittadinanza a Roma | Federico Salucci',
    metaDescription:
      'Assistenza per cittadinanza italiana, dinieghi, ricorsi TAR, ricongiungimento familiare e procedure di immigrazione a Roma e online.',
    proof:
      'Le pratiche vengono gestite con attenzione alla documentazione, ai termini e al percorso amministrativo o giudiziale più corretto.',
    services: [
      'Riconoscimento della cittadinanza italiana',
      'Ricorsi contro dinieghi della cittadinanza',
      'Giudizi innanzi ai Tribunali Amministrativi Regionali',
      'Ricongiungimento familiare',
      'Assistenza a cittadini stranieri e familiari',
      'Verifica documentale e strategia procedurale',
      'Procedure previste dalla normativa nazionale ed europea'
    ],
    steps: [
      'Analisi della posizione personale e familiare',
      'Controllo dei documenti e delle eventuali carenze',
      'Individuazione del rimedio amministrativo o giudiziale',
      'Assistenza fino all’esito della procedura'
    ],
    faqs: [
      {
        q: 'Si può intervenire contro un diniego di cittadinanza?',
        a: 'Sì, ma occorre verificare motivazione, termini e documenti. La strategia cambia in base al tipo di diniego.'
      },
      {
        q: 'La consulenza può essere online?',
        a: 'Sì. Molte pratiche possono essere avviate e seguite anche da remoto, con invio ordinato della documentazione.'
      }
    ]
  },
  {
    slug: 'diritto-civile',
    path: '/diritto-civile',
    icon: 'Landmark',
    image: site.stock.civil,
    eyebrow: 'Contenzioso e soluzioni',
    title: 'Diritto civile',
    shortTitle: 'Civile',
    headline: 'Soluzioni pratiche per controversie civili e tutela patrimoniale.',
    description:
      'Consulenza e assistenza in materia civile, con attenzione alla fase stragiudiziale, alla gestione del conflitto e all’eventuale contenzioso davanti all’Autorità competente.',
    metaTitle: 'Avvocato diritto civile a Roma | Federico Salucci',
    metaDescription:
      'Assistenza in diritto civile a Roma per controversie, responsabilità, contratti, recupero crediti e tutela dei diritti patrimoniali.',
    proof:
      'L’obiettivo è trasformare il problema giuridico in un percorso chiaro: documenti, rischi, tempi, costi e possibili esiti.',
    services: [
      'Consulenza civile stragiudiziale',
      'Controversie contrattuali',
      'Responsabilità civile e risarcimento danni',
      'Recupero crediti e diffide',
      'Tutela patrimoniale e rapporti tra privati',
      'Redazione e verifica di accordi',
      'Assistenza giudiziale davanti all’Autorità competente'
    ],
    steps: [
      'Inquadramento del problema e dei documenti disponibili',
      'Valutazione della soluzione bonaria o della diffida',
      'Stima dei rischi e dei possibili costi',
      'Azione giudiziale solo quando utile e proporzionata'
    ],
    faqs: [
      {
        q: 'Prima della causa si può tentare una soluzione bonaria?',
        a: 'Sì. Quando è conveniente, lo Studio privilegia diffide, accordi e trattative prima di arrivare al contenzioso.'
      },
      {
        q: 'Cosa serve per la prima consulenza civile?',
        a: 'Contratti, messaggi, documenti, pagamenti, fotografie e ogni elemento utile a ricostruire la vicenda in ordine cronologico.'
      }
    ]
  }
];

export const blogArticles = [
  {
    slug: 'prima-consulenza-legale-come-prepararsi',
    path: '/blog/prima-consulenza-legale-come-prepararsi',
    title: 'Prima consulenza legale: come prepararsi e quali documenti portare',
    metaTitle: 'Prima consulenza legale: documenti e preparazione | Avv. Salucci',
    description:
      'Una guida semplice per arrivare al primo incontro con le informazioni utili e ottenere un orientamento più preciso.',
    category: 'Metodo',
    date: '2026-07-08',
    image: site.stock.consultation,
    readingTime: '4 min',
    content: [
      'La prima consulenza serve a capire se esiste un problema giuridico, quali sono le strade possibili e quali documenti devono essere recuperati. Non occorre arrivare con una soluzione già pronta: è più utile arrivare con una ricostruzione ordinata dei fatti.',
      'Prima dell’incontro conviene preparare una cronologia semplice, indicando date, persone coinvolte, atti ricevuti, scadenze e comunicazioni importanti. Messaggi, email, contratti, verbali, referti, fotografie e ricevute possono cambiare in modo significativo la valutazione.',
      'L’obiettivo della consulenza è fornire un primo orientamento comprensibile: rischi, tempi, possibili costi, urgenze e prossimi passi. Quando la questione richiede approfondimenti tecnici, lo Studio indica quali verifiche sono necessarie prima di procedere.'
    ]
  },
  {
    slug: 'invalidita-civile-verbale-inps',
    path: '/blog/invalidita-civile-verbale-inps',
    title: 'Invalidità civile: cosa fare se il verbale INPS non riconosce la patologia',
    metaTitle: 'Verbale INPS negativo invalidità civile: cosa fare | Avv. Salucci',
    description:
      'Termini, documenti e valutazioni medico-legali da considerare dopo un verbale INPS non favorevole.',
    category: 'Invalidità civile',
    date: '2026-07-08',
    image: site.stock.work,
    readingTime: '5 min',
    content: [
      'Un verbale INPS non favorevole non chiude necessariamente ogni possibilità di tutela. La prima verifica riguarda i termini per agire, perché molte procedure hanno scadenze precise e non conviene rimandare.',
      'Il secondo passaggio è la valutazione della documentazione medica. Referti, certificazioni, terapie, cartelle cliniche e accertamenti specialistici devono essere coerenti con la domanda presentata e con il quadro clinico effettivo.',
      'Nei casi più complessi è utile una valutazione medico-legale, perché il ricorso non dipende solo dalla presenza della patologia ma anche dal modo in cui questa incide sulla capacità lavorativa, sull’autonomia personale o sui requisiti previsti dalla normativa.'
    ]
  },
  {
    slug: 'separazione-consensuale-e-giudiziale',
    path: '/blog/separazione-consensuale-e-giudiziale',
    title: 'Separazione consensuale e giudiziale: differenze pratiche',
    metaTitle: 'Separazione consensuale o giudiziale: differenze | Avv. Salucci',
    description:
      'Una spiegazione chiara delle principali differenze tra separazione consensuale e separazione giudiziale.',
    category: 'Famiglia',
    date: '2026-07-08',
    image: site.stock.family,
    readingTime: '4 min',
    content: [
      'La separazione consensuale presuppone un accordo tra i coniugi sui punti principali: figli, casa familiare, mantenimento, spese e rapporti patrimoniali. Quando l’accordo è completo e sostenibile, il percorso è generalmente più rapido e meno conflittuale.',
      'La separazione giudiziale diventa necessaria quando non vi è accordo o quando una delle parti ritiene indispensabile l’intervento del Tribunale per tutelare i propri diritti o quelli dei figli.',
      'La scelta non deve essere fatta in astratto. Occorre valutare la situazione familiare, il livello di conflitto, i documenti economici e l’interesse dei minori, che resta centrale in ogni decisione.'
    ]
  },
  {
    slug: 'incidente-stradale-cosa-fare',
    path: '/blog/incidente-stradale-cosa-fare',
    title: 'Incidente stradale: cosa fare nelle prime ore',
    metaTitle: 'Incidente stradale: cosa fare subito | Avv. Salucci',
    description:
      'I primi passi utili dopo un sinistro: documenti, foto, dati, referti medici e rapporti con l’assicurazione.',
    category: 'Sinistri stradali',
    date: '2026-07-08',
    image: site.stock.car,
    readingTime: '4 min',
    content: [
      'Dopo un incidente è importante raccogliere subito gli elementi essenziali: dati dei veicoli, generalità delle persone coinvolte, fotografie della scena, eventuali testimoni e documenti assicurativi.',
      'Se ci sono dolori o lesioni, è opportuno rivolgersi tempestivamente a una struttura sanitaria e conservare referti, prescrizioni e certificati. La documentazione medica iniziale è spesso decisiva per la corretta valutazione del danno.',
      'Prima di accettare offerte o firmare dichiarazioni, conviene verificare se il risarcimento copre davvero tutti i danni subiti, inclusi danni fisici, spese, fermo del veicolo e conseguenze lavorative.'
    ]
  }
];

export const homeMeta = {
  path: '/',
  metaTitle: 'Avvocato Federico Salucci | Studio legale a Roma',
  metaDescription:
    'Avvocato Federico Salucci a Roma. Consulenza e assistenza in diritto di famiglia, penale, lavoro, invalidità civile, immigrazione e sinistri stradali.',
  headline: 'Avvocato Federico Salucci',
  description: 'Assistenza legale a Roma e Viterbo'
};

export const staticPages = [
  {
    path: '/blog',
    metaTitle: 'Blog legale | Avvocato Federico Salucci',
    metaDescription:
      'Approfondimenti semplici e pratici su famiglia, lavoro, invalidità civile, sinistri stradali, penale e tutela dei diritti.'
  },
  {
    path: '/contatti',
    metaTitle: 'Contatti e appuntamenti | Avvocato Federico Salucci Roma',
    metaDescription:
      'Richiedi un appuntamento con l’Avvocato Federico Salucci a Roma, a Viterbo previo appuntamento o tramite consulenza online.'
  },
  {
    path: '/credits',
    metaTitle: 'Credits sito web | Ioppolo Studio per Avvocato Federico Salucci',
    metaDescription:
      'Credits del sito Avvocato Federico Salucci. Sito internet, SEO e presenza digitale a cura di Ioppolo Studio.'
  }
];

export const bookingTopics = [
  'Diritto di famiglia',
  'Diritto penale',
  'Invalidità civile e lavoro',
  'Sinistro stradale',
  'Immigrazione e cittadinanza',
  'Diritto civile',
  'Altro'
];

export const routePaths = [
  '/',
  ...areaPages.map((area) => area.path),
  ...staticPages.map((page) => page.path),
  ...blogArticles.map((article) => article.path)
];

export function findArea(path) {
  return areaPages.find((area) => area.path === normalizePath(path));
}

export function findArticle(path) {
  return blogArticles.find((article) => article.path === normalizePath(path));
}

export function normalizePath(path) {
  const clean = (path || '/').split('?')[0].split('#')[0];
  if (clean.length > 1 && clean.endsWith('/')) return clean.slice(0, -1);
  return clean || '/';
}

export function getMetaForPath(path) {
  const normalized = normalizePath(path);
  if (normalized === '/') return homeMeta;
  const area = findArea(normalized);
  if (area) {
    return {
      path: area.path,
      metaTitle: area.metaTitle,
      metaDescription: area.metaDescription,
      image: area.image
    };
  }
  const article = findArticle(normalized);
  if (article) {
    return {
      path: article.path,
      metaTitle: article.metaTitle,
      metaDescription: article.description,
      image: article.image
    };
  }
  return staticPages.find((page) => page.path === normalized) || homeMeta;
}
